// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_HriWq","container":"container_hV4DH","link":"link_B8sxP","linkIcon":"linkIcon_7hyGi"};